<div class="flex flex-col items-center justify-center h-screen bg-gray-100">
  <h1 class="text-[80px] font-semibold text-red-500">403</h1>
  <p class="text-xl text-gray-600 mt-4">Không có quyền truy cập</p>
  <p class="text-lg text-gray-500 mt-2">Bạn không có quyền truy cập vào trang này.</p>
  <p class="text-lg text-gray-500">Vui lòng liên hệ quản trị viên để được cấp quyền.</p>
  <a routerLink="/dashboard" class="mt-6 px-6 py-3 bg-blue-500 text-white rounded-lg shadow-md hover:bg-blue-700">
    Quay về Dashboard
  </a>
</div>
